import React from "react";

const AlertsContext = React.createContext(null);


export default AlertsContext;